module.exports = __webpack_public_path__ + "img/dealer.43967ce4.png";